"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.AcPaginationInfo = function (props) {
    var page = props.page, size = props.size, totalElements = props.totalElements, customStyle = props.customStyle;
    if (page === undefined || page < 0 || !size || !totalElements)
        return react_1.default.createElement(react_1.default.Fragment, null);
    var start = (page - 1) * size + 1;
    var end = start + size - 1;
    if (totalElements < end) {
        end = totalElements;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: customStyle, className: "fs-20 font-weight-medium" },
            totalElements,
            react_1.default.createElement("span", { className: "mx-1" }, "\u4EF6\u4E2D"), start + "-" + end,
            react_1.default.createElement("span", { className: "ml-1" }, "\u4EF6\u3092\u8868\u793A"))));
};
exports.AcPaginationInfo.displayName = 'AcPaginationInfo';
//# sourceMappingURL=AcPaginationInfo.js.map